import {useState} from 'react'
import {useNavigate} from 'react-router-dom'
import {Header, LogoutPopup} from '../../componentsRef'
import homeimg from '../../assets/img/homeimg.svg'
import '../../assets/css/HomeNew.css'

const traditionalColumns = [
	{
		title: 'En Edición',
		cards: [
			{
				date: '22/07/2026',
				id: '6100',
				name: 'Catálogo Tradicional 01',
				type: 'SELL-IN',
				roi: '0,65',
				uplift: '0,0%',
				sku: '1',
				chain: 'Jumbo',
				state: '1',
			},
			{
				date: '21/07/2026',
				id: '6096',
				name: 'Catálogo Tradicional 02',
				type: 'SELL-OUT',
				roi: '0,00',
				uplift: '0,0%',
				sku: '1',
				chain: 'Jumbo',
				state: '1',
			},
		],
	},
	{
		title: 'Revisión',
		cards: [
			{
				date: '08/06/2026',
				id: '6070',
				name: 'T2MM',
				type: 'SELL-IN',
				roi: '0,77',
				uplift: '0,9%',
				sku: '2',
				chain: 'Jumbo',
				state: '5',
				variant: 'review',
			},
			{
				date: '19/05/2026',
				id: '6067',
				name: 'Demo Tottus Induccion',
				type: 'SELL-IN',
				roi: '1,06',
				uplift: '32,4%',
				sku: '6',
				chain: 'Tottus',
				state: '9',
				variant: 'review',
			},
		],
	},
	{
		title: 'Negociación',
		cards: [
			{
				date: '19/05/2026',
				id: '6067',
				name: 'Demo Tottus Induccion',
				type: 'SELL-IN',
				roi: '0,95',
				uplift: '0,2%',
				sku: '1',
				chain: 'Tottus',
				state: '9',
			},
			{
				date: '13/05/2026',
				id: '6056',
				name: 'Test tradicional',
				type: 'SELL-IN',
				roi: '0,84',
				uplift: '0,6%',
				sku: '2',
				chain: 'Lider',
				state: '9',
			},
		],
	},
	{
		title: 'Ejecución',
		cards: [
			{
				date: '19/05/2026',
				id: '6064',
				name: 'Demo KAM KAS 19 05',
				type: 'SELL-IN',
				roi: '0,52',
				uplift: '0,0%',
				sku: '2',
				chain: 'Jumbo',
				state: '13',
			},
			{
				date: '14/05/2026',
				id: '6058',
				name: 'Test 1',
				type: 'SELL-IN',
				roi: '0,82',
				uplift: '2,0%',
				sku: '1',
				chain: 'Jumbo',
				state: '13',
			},
		],
	},
]

const chainClassName = (chain) => `traditional-card-chain traditional-card-chain-${String(chain || '').toLowerCase()}`

const TraditionalCatalogCard = ({card, onOpen}) => (
	<div
		className={`traditional-catalog-card ${card.variant === 'review' ? 'traditional-catalog-card-review' : ''}`}
		onClick={() => onOpen(card)}
		role='button'
		tabIndex={0}
		onKeyDown={(event) => {
			if (event.key === 'Enter' || event.key === ' ') onOpen(card)
		}}
	>
		<p className='traditional-card-date'>{card.date}</p>
		<h2><b>{card.id}</b> | {card.name}</h2>
		<div className='traditional-card-tags'>
			<span>{card.type}</span>
			<span>ROI <b>{card.roi}</b></span>
			<span>UPLIFT <b>{card.uplift}</b></span>
			<span>SKU <b>{card.sku}</b></span>
			<span className={chainClassName(card.chain)}>{card.chain}</span>
		</div>
	</div>
)

const HomeNewTraditional = () => {
	const [LogoutState, setLogoutState] = useState(false)
	const navigate = useNavigate()

	const openTraditionalCatalog = (card) => {
		navigate(`/traditional/${card.id}/${card.state || '5'}`)
	}

	return (
		<div className='HomeNew HomeNewTraditional'>
			{LogoutState && <LogoutPopup setLogoutState={setLogoutState} />}
			<img src={homeimg} alt='home background' className='homeimg' />
			<Header setLogoutState={setLogoutState} />
			<div className='body_area_home_new traditional-body-area'>
				<div className='traditional-page-title'>
					<h1>Tradicional</h1>
					<p>Vista independiente para la gestión tradicional de catálogos.</p>
				</div>
				<div className='traditional-columns-wrapper'>
					{traditionalColumns.map((column) => (
						<section className='traditional-column' key={column.title}>
							<div className='traditional-column-header'>
								<h2>{column.title}</h2>
								<span>{column.cards.length}</span>
							</div>
							<div className='traditional-filter-placeholder'>
								<svg width='18' height='18' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
									<path d='M3 5H21L14 13V19L10 21V13L3 5Z' stroke='#3676F5' strokeWidth='1.8' strokeLinecap='round' strokeLinejoin='round' />
								</svg>
								<span>Filtrar Catálogos</span>
							</div>
							<div className='traditional-card-list'>
								{column.cards.map((card) => (
									<TraditionalCatalogCard card={card} onOpen={openTraditionalCatalog} key={`${column.title}-${card.id}-${card.name}`} />
								))}
							</div>
						</section>
					))}
				</div>
			</div>
		</div>
	)
}

export default HomeNewTraditional
